import { FlexBox } from '@ardoq/layout';
import { currentDate } from '@ardoq/date-time';
import { ComponentCellRenderer } from '../../types';
import { PlaceholderValue } from '../../atoms';
import { getCompletenessScore } from './applicationCompletenessScore';
import { buildCompletenessPrompt } from './applicationCompletenessPrompt';
import {
  ApplicationCompletenessInteractiveScoreTag,
  ApplicationCompletenessScoreTag,
} from './ApplicationCompletenessScoreTag';

export const CompletenessCellRenderer: ComponentCellRenderer<
  unknown
> = props => {
  if (!props.data) return <PlaceholderValue />;
  const { data } = props;
  const { i18nLocale, commands, config } = props.context;
  const { askAiToImproveApplicationCompletenessRating } = commands;
  const { canAskAiToImproveApplicationCompletenessRating } = config;
  const now = currentDate();
  const { score, band } = getCompletenessScore(data, now);
  return (
    <FlexBox align="center" height="full">
      {canAskAiToImproveApplicationCompletenessRating ? (
        <ApplicationCompletenessInteractiveScoreTag
          score={score}
          band={band}
          i18nLocale={i18nLocale}
          onAskAI={() =>
            askAiToImproveApplicationCompletenessRating(
              buildCompletenessPrompt(data, now, i18nLocale, config.locale.code)
            )
          }
        />
      ) : (
        <ApplicationCompletenessScoreTag
          score={score}
          band={band}
          i18nLocale={i18nLocale}
        />
      )}
    </FlexBox>
  );
};
